export const OEMSCANLIST_CONSTANTS = {
  GET_OEM_SCAN_LIST_REQUEST: "GET_OEM_SCAN_LIST_REQUEST",
  GET_OEM_SCAN_LIST_SUCCESS: "GET_OEM_SCAN_LIST_SUCCESS",
  GET_OEM_SCAN_LIST_FAILURE: "GET_OEM_SCAN_LIST_FAILURE",
  GET_OEM_NAMES_BY_ALMATA_REQUEST: "GET_OEM_NAMES_BY_ALMATA_REQUEST",
  GET_OEM_NAMES_BY_ALMATA_SUCCESS: "GET_OEM_NAMES_BY_ALMATA_SUCCESS",
  GET_OEM_NAMES_BY_ALMATA_FAILURE: "GET_OEM_NAMES_BY_ALMATA_FAILURE",
};
